module.exports = __webpack_public_path__ + "img/barChart.11294f96.png";